import { render, staticRenderFns } from "./QuickStart.vue?vue&type=template&id=2a0f8f18"
import script from "./QuickStart.vue?vue&type=script&lang=js"
export * from "./QuickStart.vue?vue&type=script&lang=js"
import style0 from "./QuickStart.vue?vue&type=style&index=0&id=2a0f8f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports